module.exports = __webpack_public_path__ + "img/THEOS_LOGO_METAL.7a861663.svg";